import React, { ReactElement } from "react";

import * as styles from "./MenuItem.module.scss";
import { MenuItemImage } from "../../utils";
import MenuItemIconOrImage from "./MenuItemIconOrImage";

export type MenuItemProps = {
  href: string;
  trackingName: string | undefined;
  label: string;
  content?: string | ReactElement;
  image?: MenuItemImage;
  variant?: "mega" | "legacy";
};

const MenuItem: React.FC<MenuItemProps> = (props) => {
  return (
    <li role="none" className={styles.wrapper}>
      <MenuItemContent {...props} />
    </li>
  );
};

export default MenuItem;

export type MenuItemContentProps = {
  href: string;
  label: string;
  content?: string | ReactElement;
  image?: MenuItemImage;
  trackingName: string | undefined;
};

const MenuItemContent: React.FC<MenuItemContentProps> = ({
  href,
  label,
  content,
  image,
  trackingName
}) => {
  return (
    <React.Fragment>
      {image && (
        <a
          role="none"
          tabIndex={-1}
          aria-hidden
          href={href}
          className={styles.link}
        >
          <MenuItemIconOrImage image={image} label={label} variant="menu" />
        </a>
      )}
      <a
        role="menuitem"
        href={href}
        className={styles.link}
        data-content-piece={trackingName}
      >
        <span className={styles.label}>{label}</span>
        {content && <div className={styles.content}>{content}</div>}
      </a>
    </React.Fragment>
  );
};
